import { ChangesHistoryRepository } from '../repositories/changes_history.repository'
import {
    ChangesHistoryGetListParams,
    ChangesHistoryGetListResponseT,
    HistoryTypesGetListResponseT,
} from '../types/changes_history.types'

const changesHistoryRepository = new ChangesHistoryRepository()

export class ChangesHistoryService {
    async getList(
        page: number,
        params?: ChangesHistoryGetListParams
    ): Promise<ChangesHistoryGetListResponseT> {
        const response = await changesHistoryRepository.getList(page, params)
        return response.data
    }

    async getHistoryTypes(): Promise<HistoryTypesGetListResponseT> {
        const response = await changesHistoryRepository.getHistoryTypes()
        return response.data
    }
}
